import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import { Typography, Box, Grid } from '@mui/material';

const TermsOfServicePage = () => {
    return (
        <>
            <Box sx={{ flexGrow: 1, p: 2 }}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <Typography variant="body1">
<section id="terms-of-service">
  <h1>Terms of Service</h1>
  <p><strong>Effective Date:</strong> May 1, 2025</p>

  <p>Welcome to <strong>ggc.me</strong>. By accessing or using our platform, you agree to comply with and be bound by the following Terms of Service. Please read them carefully.</p>

  <h2>Acceptance of Terms</h2>
  <p>By accessing ggc.me or using its services, you confirm your agreement to these Terms and our <a href="https://ggc.me/privacy">Privacy Policy</a>. If you do not agree, please discontinue use of our services.</p>

  <h2>Use of Services</h2>
  <ul>
    <li>You may use our services for lawful purposes only.</li>
    <li>You must provide accurate and complete account information.</li>
    <li>You are responsible for maintaining the confidentiality of your login credentials.</li>
  </ul>

  <h2>Subscriptions and Payments</h2>
  <ul>
    <li>Paid features and subscriptions are processed via third-party providers such as Stripe and Apple.</li>
    <li>All payments are subject to the terms and conditions of these providers.</li>
    <li>ggc.me is not responsible for payment failures or disputes with those providers.</li>
  </ul>

  <h2>Prohibited Activities</h2>
  <ul>
    <li>Impersonating others or providing false information</li>
    <li>Reverse-engineering or interfering with the site’s functionality or security</li>
    <li>Posting unlawful, harmful, or abusive content</li>
  </ul>

  <h2>User Content</h2>
  <ul>
    <li>You retain rights to any content you submit.</li>
    <li>By uploading or sharing content, you grant ggc.me a non-exclusive license to display and distribute it within the platform.</li>
    <li>We reserve the right to remove or modify content that violates these terms.</li>
  </ul>

  <h2>Privacy</h2>
  <p>Our handling of your personal data is governed by our <a href="https://ggc.me/privacy">Privacy Policy</a>. We take your privacy seriously and use industry-standard protections.</p>

  <h2>Termination</h2>
  <ul>
    <li>We may suspend or terminate accounts that violate these Terms or applicable laws.</li>
    <li>You may delete your account at any time by contacting us.</li>
  </ul>

  <h2>Legal Compliance</h2>
  <p>ggc.me complies with applicable laws including GDPR and CCPA. We cooperate with law enforcement when required and uphold your rights under data protection laws.</p>

  <h2>Changes to Terms</h2>
  <p>We may update these Terms from time to time. Changes will be posted here with a revised effective date. Continued use after updates indicates your acceptance.</p>

  <h2>Creator Payout Terms</h2>
  <ul>
    <li><strong>Minimum Payout Threshold:</strong> $50 USD</li>
    <li><strong>On-Demand Payouts:</strong> Creators may request payouts anytime. Processing typically takes up to 5 business days.</li>
    <li><strong>Eligible Earnings:</strong> Only cleared funds after fees and hold periods are eligible for withdrawal.</li>
    <li><strong>Payment Methods:</strong> Available options include bank transfers, PayPal, and region-specific alternatives.</li>
    <li><strong>Verification:</strong> Identity and tax residency verification may be required prior to payout.</li>
    <li><strong>Transaction Fees:</strong> Fees may apply depending on method, currency conversion, and location.</li>
    <li><strong>Currency & Conversion:</strong> Payouts default to USD. Currency conversions are subject to external provider rates.</li>
    <li><strong>Tax Compliance:</strong>
      <ul>
        <li>Canadian creators are responsible for reporting earnings locally. No taxes are withheld on Canadian resident payouts.</li>
        <li>Non-resident creators may have 15% Canadian tax withheld unless valid treaty documentation (e.g. NR301) is provided.</li>
      </ul>
    </li>
    <li><strong>Partial Payouts:</strong> Allowed if the payout balance exceeds the threshold.</li>
    <li><strong>Retention of Earnings:</strong> Funds remain in the account until withdrawn. They do not expire.</li>
    <li><strong>Reporting:</strong> Earnings summaries are available in your dashboard for review and recordkeeping.</li>
  </ul>
  <p>These Creator Payout Terms are subject to change. Continued use of payout features constitutes acceptance of any updates.</p>

  <h2>Contact</h2>
  <p>Questions or concerns? Reach us at <a href="mailto:info@ggc.me">info@ggc.me</a></p>
</section>

                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>

                    </Grid>
                </Grid>
            </Box>
        </>
    )
}
export default TermsOfServicePage;